export default "__VITE_ASSET__CbeIcIUL__"